// extracted by mini-css-extract-plugin
export default {"answer":"answer_answer__bkWwL"};